import Plyr from 'plyr';

import { controlledVideoPlayers, CLASSES } from '../helpers/consts';

const pausePlayers = (playersArr, currPlayer) => {
	playersArr.forEach((player) => {
		if(player === currPlayer) return;
		player.pause();
	});
};

export const getInitedVideoPlayer = (video, options) => {
	const player = new Plyr(video, {
		ratio: '16:9',
		controls: ['play', 'progress', 'volume'],
		autoplay: true,
		vimeo: {
			background: true,
		},
		...options
	});

	video.dataset.plyrEmbedId = video.dataset.vimeoId;
	player.source = {
		type: 'video',
		sources: [{
			src: video.dataset.vimeoId,
			provider: 'vimeo',
		}],
	};
	return player;
};

const initLocalPlayer = (el) => {
	return new Plyr(el, {
		controls: [],
		ratio: '9:16',
		muted: true,
		// loop: true,
		autoplay: true,
	});
};

const initLocalVideo = (el) => {
	const sourceEl = el.querySelector('source');
	const dataSrc = sourceEl.getAttribute('data-src');

	sourceEl.src = dataSrc;
	el.load();

	const player = initLocalPlayer(el);

	return player;

};

export const getSimplePlayer = (wrapper, options) => {
	const video = wrapper.querySelector('video');
	const player = getInitedVideoPlayer(video, options);

	player.on('play', () => {
		setTimeout(() => {
			wrapper.classList.add(CLASSES.mediaLoaded);
		}, 400);
	});

	return player;
};
const initSimpleClickVideo = (wrapper) => {
	const video = wrapper.querySelector('video');
	const playElems = wrapper.querySelectorAll('.js-video-play-btn');

	playElems.forEach((el) => {

		el.addEventListener('click', () => {
			const player = getInitedVideoPlayer(video, {
				volume: 0.5,
			});
			controlledVideoPlayers.push(player);

			player.on('play', () => {
				pausePlayers(controlledVideoPlayers, player);
				player.volume = 0.5;
				wrapper.classList.add(CLASSES.mediaLoaded);
			});
		});
	});
};

export const initlocalLazyScrollAutoplay = (wrappers) => {
	const scrollPlayers = [];
	const observer = new IntersectionObserver((entries) => {

		entries.forEach((entry) => {
			const wrapper = entry.target;
			const currWrapperIndex = wrappers.indexOf(wrapper);
			const video = wrapper.querySelector('video');
			let player = null;

			if(entry.isIntersecting) {
				const isInited = wrapper.classList.contains(CLASSES.mediaInited);
				if(!isInited) {

					wrapper.classList.add(CLASSES.mediaInited);
					player = initLocalVideo(video);
					player.on('ready', () => {
						player.volume = 0;
						player.play();

					});
					player.on('play', () => {
						setTimeout(() => {
							wrapper.classList.add(CLASSES.mediaLoaded);
						}, 400);
					});

					scrollPlayers.push(player);
				}
				else {
					if(scrollPlayers[currWrapperIndex]) {
						scrollPlayers[currWrapperIndex].play();
					}
				}
			}
			else {
				if(scrollPlayers[currWrapperIndex]) {
					scrollPlayers[currWrapperIndex].pause();
				}
			}
		});

	}, { threshold: 0 }); // threshold: 0.5 означает, что хотя бы половина элемента должна быть видима

	// Начинаем наблюдение
	wrappers.forEach(wrapper => observer.observe(wrapper));

};

export const initScrollAutoplayVideo = (wrappers, options = {}) => {
	const scrollPlayers = [];
	const observer = new IntersectionObserver((entries) => {

		entries.forEach((entry) => {
			const wrapper = entry.target;
			const currWrapperIndex = wrappers.indexOf(wrapper);
			const video = wrapper.querySelector('video');
			let player = null;

			if(entry.isIntersecting) {
				const isInited = wrapper.classList.contains(CLASSES.mediaInited);
				if(!isInited) {

					wrapper.classList.add(CLASSES.mediaInited);
					player = getInitedVideoPlayer(video, {
						muted: true,
						...options
					});
					player.on('ready', () => {
						player.volume = 0;
						player.play();

					});
					player.on('play', () => {
						setTimeout(() => {
							wrapper.classList.add(CLASSES.mediaLoaded);
						}, 400);
					});
					scrollPlayers.push(player);
				}
				else {
					if(scrollPlayers[currWrapperIndex]) {
						scrollPlayers[currWrapperIndex].volume = 0;
						scrollPlayers[currWrapperIndex].play();
					}
				}
			}
			else {
				if(scrollPlayers[currWrapperIndex]) {
					scrollPlayers[currWrapperIndex].pause();
					scrollPlayers[currWrapperIndex].volume = 0;
				}
			}
		});

	}, { threshold: 0 }); // threshold: 0.5 означает, что хотя бы половина элемента должна быть видима

	// Начинаем наблюдение
	wrappers.forEach(wrapper => observer.observe(wrapper));

};


export const initStartLoadScrollAutoplayVideo = (wrappers, options = {}) => {
	const scrollPlayers = [];

	wrappers.forEach((wrapper) => {
		const video = wrapper.querySelector('video');
		wrapper.classList.add(CLASSES.mediaInited);
		let player = player = getInitedVideoPlayer(video, {
			muted: true,
			autoplay: false,
			...options
		});
		player.on('ready', () => {
			player.volume = 0;
			player.play();

		});
		player.on('play', () => {
			setTimeout(() => {
				wrapper.classList.add(CLASSES.mediaLoaded);
			}, 400);
		});
		scrollPlayers.push(player);
	});

	const observer = new IntersectionObserver((entries) => {

		entries.forEach((entry) => {
			const wrapper = entry.target;
			const currWrapperIndex = wrappers.indexOf(wrapper);
			// const video = wrapper.querySelector('video');
			// let player = null;


			if(entry.isIntersecting) {
				if(scrollPlayers[currWrapperIndex]) {
					scrollPlayers[currWrapperIndex].volume = 0;
					scrollPlayers[currWrapperIndex].play();
				}
			}
			else {
				if(scrollPlayers[currWrapperIndex]) {
					scrollPlayers[currWrapperIndex].pause();
					scrollPlayers[currWrapperIndex].volume = 0;
				}
			}
		});

	}, { threshold: 0 }); // threshold: 0.5 означает, что хотя бы половина элемента должна быть видима

	// Начинаем наблюдение
	wrappers.forEach(wrapper => observer.observe(wrapper));

};

export default () => {
	const clickVideos = document.querySelectorAll('.js-simple-video');
	clickVideos.forEach(video => initSimpleClickVideo(video));

	const scrollAutoplayVideos = [...document.querySelectorAll('.js-scroll-autoplay-video')];
	if(scrollAutoplayVideos.length)	initScrollAutoplayVideo(scrollAutoplayVideos);
};
